import React from "react";

function ErrorPage() {
  return <div> error</div>;
}

export default ErrorPage;
